import {DoughnutChart} from "./base/DoughnutChart";
import {CHART_COLORS} from "./consts/COLOR_SETS";
import {useMemo} from "react";
import useAppContext from "../../hooks/useAppContext";

interface TemplatesAnalyzerProps {
    type: string;
}

export const TemplatesAnalyzer = ({ type }: TemplatesAnalyzerProps) => {
    const { data: { templatesAnalyzer } } = useAppContext();
    const isDataLoaded = useMemo(() => !!templatesAnalyzer.data?.length, [templatesAnalyzer.data?.length]);
    if(!templatesAnalyzer.data?.length) return null;

    const labels = templatesAnalyzer.data?.map((row: any) => row.title);
    const colors = CHART_COLORS.map(color => color.solid);

    const getTitle = () => {
        if(type === "sent") {
            return 'Messages Sent';
        } else if(type === "clicked") {
            return 'Messages Clicked On';
        } else if(type === "read") {
            return 'Read Messages';
        } else if(type === "conversionRate") {
            return 'Conversion Rate';
        } else if(type === "ctr") {
            return 'CTR';
        } else if(type === 'deliveryRate') {
            return 'Delivery Rate';
        }
    }

    const getDataSets = () => {
        const clicks = templatesAnalyzer.data?.map((row: any) => row.clicked);
        const sent = templatesAnalyzer.data?.map((row: any) => row.sent);
        const read = templatesAnalyzer.data?.map((row: any) => row.read);
        if(type === "sent") {
            return [{label: 'Total Sent', values: sent, backgroundColor: colors}];
        } else if(type === "clicked") {
            return [{label: 'Total Clicks', values: clicks, backgroundColor: colors}];
        } else if(type === "read") {
            return [{label: 'Total Read', values: read, backgroundColor: colors}];
        } else if(type === "converted") {
            return [{label: 'Total Read', values: templatesAnalyzer.data?.map((row: any) => row.converted), backgroundColor: colors}];
        } else if(type === "sent") {
            return [{label: 'Total Sent', values: templatesAnalyzer.data?.map((row: any) => row.sent), backgroundColor: colors}];
        } else if(type === "conversionRate") {
            return [{label: 'Conversion Rate', values: templatesAnalyzer.data?.map((row: any) => row.conversionRate), backgroundColor: colors}];
        } else if(type === "ctr") {
            return [{label: 'CTR', values: templatesAnalyzer.data?.map((row: any) => row.ctr), backgroundColor: colors},];
        } else if(type === 'deliveryRate') {
            const delivered = templatesAnalyzer.data?.reduce((total: number, row: any) => total + parseInt(row.delivered), 0);
            const unDelivered = templatesAnalyzer.data?.reduce((total: number, row: any) => total + parseInt(row.unDelivered), 0);
            return [{label: 'Delivery Rate', values: [delivered, unDelivered], backgroundColor: colors},];
        }
    };

    const dataSets = getDataSets();

    const getTotalValue = () => {
        if(type === 'clicked') {
            const clicks = templatesAnalyzer.data?.reduce((total: number, row: any) => total + parseInt(row.clicked), 0);
            const sent = templatesAnalyzer.data?.reduce((total: number, row: any) => total + parseInt(row.sent), 0);
            return `${Math.round(clicks / sent * 100)}%`;
        }
        if(type === 'read') {
            const read = templatesAnalyzer.data?.reduce((total: number, row: any) => total + parseInt(row.read), 0);
            const sent = templatesAnalyzer.data?.reduce((total: number, row: any) => total + parseInt(row.sent), 0);
            return `${Math.round(read / sent * 100)}%`;
        }
        if(type === 'deliveryRate') {
            const delivered = templatesAnalyzer.data?.reduce((total: number, row: any) => total + parseInt(row.read), 0);
            const unDelivered = templatesAnalyzer.data?.reduce((total: number, row: any) => total + parseInt(row.sent), 0);
            return `${Math.round(delivered / (delivered + unDelivered) * 100)}%`;
        }
        return undefined;
    }

    const getLabels = () => {
        if(type === 'deliveryRate') {
            return ['Delivered', 'Un-Delivered']
        }
    }


    return <DoughnutChart
        labels={labels}
        dataSets={dataSets}
        data={templatesAnalyzer.data}
        title={getTitle()}
        isDataLoaded={isDataLoaded}
        totalLabel={getTitle()}
        cutout={104}
        totalValue={getTotalValue()}
    />
}